import React from 'react'

export const Title = ({ text }) => <p className='text-muted p-1'>{text}</p>
